import {UPDATE_MIGRATION_ENTITY, CLEAR_MIGRATION_ENTITY} from '../../action.types'

export const updateMigrationEntity = migrationEntity => ({type: UPDATE_MIGRATION_ENTITY, payload: migrationEntity})

export const clearMigrationEntity = migrationEntity => ({type: CLEAR_MIGRATION_ENTITY})




// WEBPACK FOOTER //
// ./src/js/actions/migration-entity/migration.entity.actions.js